import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';

import { Button, Pill } from '@feathr/components';

import * as styles from './KeywordSuggestion.css';

interface IKeywordSuggestionProps {
  text: string;
  onAdd: (text: string) => void;
  disabled?: boolean;
}

/**
 * One suggested keyword, as a chip that adds it. Its own component so the click handler
 * can close over its text rather than each row building one inline. Same Button+Pill
 * combo as {@link KeywordChip}, so the two sit on a consistent rhythm when wrapped.
 *
 * @param props - {@link IKeywordSuggestionProps}.
 */
function KeywordSuggestion({
  text,
  onAdd,
  disabled = false,
}: Readonly<IKeywordSuggestionProps>): JSX.Element {
  function handleClick(): void {
    onAdd(text);
  }

  return (
    <Button
      className={styles.root}
      disabled={disabled}
      name={'add-suggested-keyword'}
      onClick={handleClick}
      type={'naked'}
    >
      <Pill prefix={faPlus} theme={'cyan'} truncate={false}>
        {text}
      </Pill>
    </Button>
  );
}

export default KeywordSuggestion;
